import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  width: 100%;
  background-color: #363435;
  padding: 30px 12px 0;

  @media (min-width: 480px) {
    padding: 40px 24px 0;
  }

  @media (min-width: 768px) {
    padding: 24px 24px 0;
  }

  @media (min-width: 1024px) {
    padding: 24px 104px 0;
  }

  .btn__footerbtn--button {
    @media (min-width: 768px) {
      padding: 14px 0;
      height: 44px;
      display: flex;
      align-items: center;
    }
  }

  .btn__footerbtnout--button {
    border: 1px solid ${(props) => props.theme.colors.brand1.pure};
    background-color: transparent;
  }

  .btn__endMessage--pesquisar {
    font-weight: bold;
    color: #424242;

    span {
      display: flex;
    }

    svg {
      width: 18px;
      height: 18px;
      margin-right: 3px;
      path {
        fill: #424242;
      }
    }

    @media (min-width: 480px) {
      width: 230px;
    }
  }

  .btn__endMessage--limpar {
    margin: 10px;
    background-color: #363435;
    border: 1px solid #dbc7b8;
    color: #dbc7b8;
    font-weight: bold;

    svg {
      margin-right: 6px;
      path {
        fill: #dbc7b8;
      }
    }

    @media (min-width: 480px) {
      width: 230px;
    }
  }


  .settings--container {
  
    @media (max-width: 767px) {
      gap: 8vw;
      > button {
        margin: 0 auto;
        width: 40vw;
        justify-content: center;
      }
    }

    @media (min-width: 768px) {
      display: flex;
      justify-content: space-between;
      margin-right: 22px;
    }
  }

`;

export const FooterButtonNameCreateWishList = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin-right: 8px;
    width: 15px;
    height: 15px;

    @media (min-width: 480px) {
      width: auto;
      height: auto;
    }

    @media (min-width: 768px) {
      width: 10px;
      height: 10px;
    }

    > span {
      font-weight: 550;
      font-size: 1.3rem;
      line-height: 30px;
      color: ${(props) => props.theme.colors.typography3.pure};

      @media (min-width: 480px) {
        font-size: 1.5rem;
      }

      @media (min-width: 768px) {
        font-size: 0.75rem;
        line-height: initial;
      }
    }
  }
`;

export const FooterButtonNameCreateWishListOut = styled.div`
  > span {
    font-weight: 550;
    font-size: 1.3rem;
    line-height: 30px;
    color: ${(props) => props.theme.colors.brand1.pure};

    @media (min-width: 768px) {
      font-size: 0.75rem;
    }
  }
`;

export const ProductsHeaderContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 8px 10px;
`;

export const ContainerTextSearch = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
export const TextSearchItem = styled.p`
  text-align: center;
  color: white;
  font-size: 1rem;

  span {
    margin-left: 60px;
    margin-right: 30px;
  }

  button {
    background-color: transparent;
    border: none;
    color: #757575;
    font-size: 0.75rem;
    vertical-align: bottom;
    span {
      margin-left: 5px;
      text-decoration: underline;
    }
  }
`;
